import { getRoute } from '@/services/utility';
import { TRIP_STATE } from '@/store/mutation-types';
// import language from '@/services/language';
import { LangManager } from '@/services/language';

export class ResourcePlugin {

    install (Vue) {
        // ADD HERE MORE RESOURCES
        /* let localLanguage = language.first ? language.first : 'es';
        let storageLanguage = window.localStorage.getItem('local_lang');
        if (storageLanguage) {
            localLanguage = storageLanguage;
        }
        console.log('localLanguage', localLanguage); */
        Vue.prototype.$getLang = function () {
            return LangManager.getLang();
        };
        Vue.prototype.$setLang = function (lang) {
            return LangManager.setLang(lang);
        };
        Vue.prototype.$translateFromText = function (text) {
            return LangManager.translateFromText(text);
        };

        Vue.$profile = function (url) {
            return getRoute(url, '/img/profile/');
        };
        Vue.$shortcut = function (url) {
            return getRoute(url, '/img/shortcuts/');
        };
        Vue.prototype.$img = function (name) {
            return require('resources/default/img/' + name);
        };
        Vue.prototype.$svg = function (name) {
            return require('!svg-inline-loader!resources/default/svg/' + name);
        };
        Vue.prototype.$profile = function (url) {
            return Vue.$profile(url);
        };
        Vue.prototype.$shortcut = function (url) {
            return Vue.$shortcut(url);
        };
        Vue.prototype.TRIP_STATE = TRIP_STATE;
    }
}



// WEBPACK FOOTER //
// ./src/components/plugin-resource.js